import { Img } from "globalStyles";
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BLOG_ROUTE, LOGIN_ROUTE } from "routes";
import { ClipImage, DoubleArrow, StdMeeting } from "utils/assets";

import {
  ClippedContainer,
  ClippedShape,
  ClippedText,
  FirstDiv,
  ImageContentWrapper,
  LeftText,
  LoanBlogBtn,
  LoanContainer,
  LoanFooterButton,
  LoanItemDiv,
  LoanLeft,
  LoanRight,
  LoanTextHead,
  LoanTextPara,
  LoanTextWrapper,
  SecondDiv,
} from "./style";
import { getHomeAnalytics } from "services/MiscService";

function formatNumber(num) {
  if (num >= 1_000_000_000_000) return (num / 1_000_000_000_000).toFixed(1) + " trillion";
  if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1) + " billion";
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + " million";
  if (num >= 1_000) return (num / 1_000).toFixed(1) + " thousand";
  return num;
}

const LoanComp = () => {
  const [analytics, setAnalytics] = useState({
    beneficiaries: 0,
    disbursed_amount: 0,
    total_institutions: 0,
  });

  const updateAnalytics = useCallback(async () => {
    const res = await getHomeAnalytics();
    if (res.data) {
      setAnalytics(res.data);
    }
  }, []);

  useEffect(() => {
    updateAnalytics();
  }, [updateAnalytics]);

  const LoanItems = [
    "Create an account",
    "Complete onboarding process",
    "Provide Documents",
    "Apply for a loan",
  ];

  function amountInWords(num) {
  if (num === 0) return "Zero";

  const below20 = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
    "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];

  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty",
    "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  const thousands = ["", "Thousand", "Million", "Billion"];

  const helper = (n) => {
    if (n === 0) return "";
    else if (n < 20) return below20[n] + " ";
    else if (n < 100)
      return tens[Math.floor(n / 10)] + " " + helper(n % 10);
    else
      return (
        below20[Math.floor(n / 100)] +
        " Hundred " +
        helper(n % 100)
      );
  };

  let word = "";
  let index = 0;

  while (num > 0) {
    if (num % 1000 !== 0) {
      word =
        helper(num % 1000) +
        thousands[index] +
        " " +
        word;
    }
    num = Math.floor(num / 1000);
    index++;
  }

  return word.trim();
}

const getYearsFrom2020 = () => {
  const amountInWords = (num) => {
    if (num === 0) return "Zero";

    const below20 = [
      "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
      "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
      "Sixteen", "Seventeen", "Eighteen", "Nineteen"
    ];

    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    const thousands = ["", "Thousand", "Million", "Billion"];

    const helper = (n) => {
      if (n === 0) return "";
      if (n < 20) return below20[n] + " ";
      if (n < 100) return tens[Math.floor(n / 10)] + " " + helper(n % 10);
      return below20[Math.floor(n / 100)] + " Hundred " + helper(n % 100);
    };

    let word = "";
    let i = 0;

    while (num > 0) {
      if (num % 1000 !== 0) {
        word = helper(num % 1000) + thousands[i] + " " + word;
      }
      num = Math.floor(num / 1000);
      i++;
    }

    return word.trim();
  };

  const currentYear = new Date().getFullYear();
  const years = currentYear - 2020;

  return {
    years,
    inWords: amountInWords(years),
  };
};

const {inWords} = getYearsFrom2020()

  return (
    <LoanContainer>
      <FirstDiv>
        <LoanLeft>
          <LeftText>
            <LoanTextHead>
              Navigate through your academic journey effortlessly.
            </LoanTextHead>
            <LoanTextPara>
              Over the last <span>{inWords} years</span>, the Bayelsa State Higher Education
              Students Loan Board (BYSHELB) has successfully disbursed over{" "}
              <span>{analytics.disbursed_amount ?formatNumber(1987355600 + analytics.disbursed_amount) :"1.5 billion"} Naira</span> in loans to more than{" "}
              <span>{analytics?.beneficiaries ? formatNumber(9192 + analytics.beneficiaries) : "5,000 thousand"} Bayelsa indigines</span> enrolled in Nigerian tertiary
              institutions. This accomplishment underscores BYSHELB's dedication
              to promoting higher education and empowering individuals within
              the state.
            </LoanTextPara>
          </LeftText>
          <LoanBlogBtn to={BLOG_ROUTE}> Read more... </LoanBlogBtn>
        </LoanLeft>
        <LoanRight>
          <Img src={StdMeeting} alt="Student Image" />
        </LoanRight>
      </FirstDiv>
      <SecondDiv>
        <ImageContentWrapper>
          <LoanTextWrapper>
            <ClippedContainer>
              <ClippedText>Loan process is simple and fast</ClippedText>
              <ClippedShape src={ClipImage} />
            </ClippedContainer>

            {LoanItems.map((item, key) => {
              return (
                <>
                  <LoanItemDiv key={key}>
                    <Img src={DoubleArrow} alt="arrow-right" />
                    <h2>{item}</h2>
                  </LoanItemDiv>
                </>
              );
            })}
            <Link to={LOGIN_ROUTE}>
              <LoanFooterButton>Apply</LoanFooterButton>
            </Link>
          </LoanTextWrapper>
        </ImageContentWrapper>

        {/* </LoanInfoWrapper> */}
        {/* <LoanFootComp>
          <LoanFootHead>Loan process is simple and fast</LoanFootHead>
          <Link to={LOGIN_ROUTE}>
            <HeroBtn>Apply Now!</HeroBtn>
          </Link>
        </LoanFootComp> */}
      </SecondDiv>
    </LoanContainer>
  );
};

export default LoanComp;
